import { GetDashboardAcademicsResponse, OnLoadEvent } from './events';
import { Context, Scope } from './types';

export const loadingTrue = (): Partial<Context> => {
  return {
    loading: true,
  };
};

export const loadingFalse = (): Partial<Context> => {
  return {
    loading: false,
  };
};

export const setData = (scope: Scope): Partial<Context> => {
  const { output } = scope.event as GetDashboardAcademicsResponse;
  return {
    data: output.data,
  };
};

export const setProviderIdFromEvent = (scope: Scope): Partial<Context> => {
  const { providerId } = scope.event as OnLoadEvent;
  return { providerId };
};
